import React from 'react'
import { AnimalGallery } from 'src/components/AnimalGallery'
import { IAnimal } from 'src/dto/animal.dto'
import { useAnimalGallery } from './hooks/useAnimalGallery'

interface GalleryProps {
  data?: IAnimal
}

export const Gallery: React.FC<GalleryProps> = ({ data }) => {
  const { photos, isLoading, isRefreshing, addPhotos, removePhoto, retryUpload, uploadingPhotos } = useAnimalGallery(
    data?.idAnimal
  )

  return (
    <AnimalGallery
      photos={photos}
      onAddPhotos={addPhotos}
      onRemovePhoto={removePhoto}
      onRetryUpload={retryUpload}
      isLoading={isRefreshing || isLoading}
      uploadingPhotos={uploadingPhotos}
    />
  )
}
